/**
 * Market-aware utility functions.
 * market: 'IN' = India (default), 'US' = United States
 */

export const getCurrencySymbol = (market) => market === 'US' ? '$' : '₹';

export const formatCurrency = (value, market) => {
  const num = Number(value) || 0;
  if (market === 'US') {
    if (Math.abs(num) >= 1e9) return `$${(num / 1e9).toFixed(2)}B`;
    if (Math.abs(num) >= 1e6) return `$${(num / 1e6).toFixed(2)}M`;
    if (Math.abs(num) >= 1e3) return `$${(num / 1e3).toFixed(2)}K`;
    return `$${num.toFixed(2)}`;
  }
  // India: Crores > Lakhs > Thousands
  if (Math.abs(num) >= 1e7) return `₹${(num / 1e7).toFixed(2)} Cr`;
  if (Math.abs(num) >= 1e5) return `₹${(num / 1e5).toFixed(2)} L`;
  return `₹${(num / 1e3).toFixed(2)} K`;
};

export const formatCurrencyFull = (value, market) => {
  const num = Number(value) || 0;
  if (market === 'US') {
    return `$${num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  }
  return `₹${num.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const getIdentifierLabel = (market) => market === 'US' ? 'SSN' : 'PAN';

export const getIdentifierPlaceholder = (market) =>
  market === 'US' ? 'XXX-XX-XXXX' : 'ABCDE1234F';

export const getExchangeLabel = (market) =>
  market === 'US' ? 'NASDAQ / NYSE' : 'NSE / BSE';

export const getMarketLabel = (market) =>
  market === 'US' ? 'United States' : 'India';

export const getMarketIndices = (market) =>
  market === 'US'
    ? ['S&P 500', 'NASDAQ Composite', 'Dow Jones']
    : ['NIFTY 50', 'SENSEX'];
